import { IInfoImagesProduct } from "./interface"
import { ContainerDelete, ProductImage, ThirdCol } from "./style"
import EditIcon from "../../assets/icons/edit.svg"
import React, { useState } from "react"

const InfoImagesProduct = ({
    images,
    setSelectedImgId
}: IInfoImagesProduct) => {

    return (
        <>
            { 
                images.map((img: any, index: number) => {
                    return (
                        <ThirdCol key={index}>
                            <ProductImage src={"https://api.100pay.org/files/" + img.photo}/>
                            <ContainerDelete onClick={() => {
                                setSelectedImgId(img.id)
                            }}>
                                <img src={EditIcon}/>
                            </ContainerDelete>
                        </ThirdCol>
                    )
                })
            }
        </>
    )
}

export default InfoImagesProduct